import { useRange } from 'react-instantsearch';
import PriceRangeFilter from '../product-search/shared/PriceRangeFilter';

function CustomPriceRange({ range, setRange }) {
  const { range: minRange, refine: refineMin } = useRange({ attribute: 'min_price' });
  const { range: maxRange, refine: refineMax } = useRange({ attribute: 'max_price' });

  return (
    <PriceRangeFilter
      minValue={range.min}
      maxValue={range.max}
      minPlaceholder={minRange.min?.toString()}
      maxPlaceholder={maxRange.max?.toString()}
      onChangeMin={(value) => {
        setRange(prev => ({ ...prev, min: value }));
        refineMin([Number(value) || undefined, undefined]);
      }}
      onChangeMax={(value) => {
        setRange(prev => ({ ...prev, max: value }));
        refineMax([undefined, Number(value) || undefined]);
      }}
    />
  );
}

export default CustomPriceRange;
